import i18n from 'helper/i18n';

import { ContentTypePoolWorkoutDtoType } from 'types/services/magnolia/dtos/ContentTypePoolWorkoutDto';

// TODO: Refactor to ENUM
export const FILTER_ID = 'WORKOUT_DURATION' as const;

export const FILTER_FACTORY = {
	BELOW_15: (duration: number) => duration < 900,
	BETWEEN_15_30: (duration: number) => duration >= 900 && duration < 1800,
	BETWEEN_30_60: (duration: number) => duration >= 1800 && duration <= 3600,
	ABOVE_60: (duration: number) => duration > 3600,
};

export const FILTER: { [key: string]: keyof typeof FILTER_FACTORY } = {
	BELOW_15: 'BELOW_15',
	BETWEEN_15_30: 'BETWEEN_15_30',
	BETWEEN_30_60: 'BETWEEN_30_60',
	ABOVE_60: 'ABOVE_60',
};

export const FILTER_LABELS: { [key: string]: React.ReactNode } = {
	BELOW_15: i18n(`react.impulsCoach.components.tagFilter.workout.${FILTER_ID}.${FILTER.BELOW_15}`),
	BETWEEN_15_30: i18n(`react.impulsCoach.components.tagFilter.workout.${FILTER_ID}.${FILTER.BETWEEN_15_30}`),
	BETWEEN_30_60: i18n(`react.impulsCoach.components.tagFilter.workout.${FILTER_ID}.${FILTER.BETWEEN_30_60}`),
	ABOVE_60: i18n(`react.impulsCoach.components.tagFilter.workout.${FILTER_ID}.${FILTER.ABOVE_60}`),
};

export function filterForDuration(
	filter: /* TODO: $Values<typeof FILTER> */ any
): (item: ContentTypePoolWorkoutDtoType) => boolean {
	return (item: ContentTypePoolWorkoutDtoType) => FILTER_FACTORY[filter](item.duration);
}
